import React, {Component} from 'react';
import Select from 'react-select';

class MultiSelectSurvey extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
        }
    }

    onChangeValue = (e) => {
        let list = e;
        let data = this.state.data;
        data[this.props.name] = list
        this.setState({data});
        this.props.listener(this.props.name, list);
    }

    render() {
        return(
            <Select
                wrapperStyle={{position: 'relative', zIndex: 9999}}
                className="multiselect"
                isMulti
                onChange={this.onChangeValue}
                placeholder='Seçiniz'
                options={this.props.options}
                noOptionsMessage={() => 'Seçenek Yok!'}
                value={this.props.content === undefined ? null: this.props.content }
            />
        )
    }

}
export default MultiSelectSurvey;